const ASSET =
  "https://customer-assets-cm19k8pv.emergentagent.net/wingman/df37df65-a286-406b-898d-8f9282789467/attachments/";
const img = (h) => `${ASSET}${h}_image.bin`;
const px = (id, w = 1200) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;
const us = (id, w = 1200) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const LOGO = "/logo.jpg";

export const REAL_PHOTOS = {
  moments: ASSET + "7940f484656048039c83e47ac142786a_IMG_0859.JPG",
  bridalPortrait: ASSET + "3436128e713b4b6ba861dc68458ffebb_IMG_0860.JPG",
  aisle: ASSET + "e5f6e88aac7d4a41abd099e851b7ee32_IMG_0864.JPG",
  rituals: ASSET + "82c16f88da9d4b598de85ef56b93f445_IMG_0863.JPG",
  sunsetGarden: ASSET + "4b965311239948408a71011a07634bf4_IMG_0858.JPG",
  stageFireworks: ASSET + "31327529bcd14ee59be8bb5ac18373c7_IMG_0861.JPG",
  decorVignettes: ASSET + "88635620b3ab40ca9acbc003f2e0fa63_IMG_0855.JPG",
  ceremony: ASSET + "ad77c22df1164a989abe9107cf0eeeb3_IMG_0862.JPG",
  gazeboFireworks: ASSET + "21c7568a589444e58430d9a65165c5b6_IMG_0856.JPG",
  treeVenue: ASSET + "2905364033e94d2a9bc2bfc5d9c7d3e3_IMG_0857.JPG",
  heroJoyful: img("3fc760d8399e4067ba4834a5855a33e5"),
};

const P = REAL_PHOTOS;

export const COUPLE_PHOTOS = [
  img("e9c7683dbc134699974540683470e156"),
  img("752c46f756aa48ec8de7eed7ba293f88"),
  img("73419867e42d4c4bb879adcb68be4694"),
  img("f0d4b238dfe340f4bd73e03c955bf2c2"),
  img("f243794710794e54be61603247b075eb"),
  img("6bfa2c49dfaf41ef8ea61788939d23e3"),
  img("9965c3e0a2f94d9ab8f7ba09c47e1333"),
  img("bc5e7d8603ce4478bc59d9f8f4222c59"),
];

export const BEACH_PHOTOS = [
  img("7113f4dc1f90457982daaac6e7b45652"),
  img("25bcec7b805743bd867491a4467dbdfe"),
  img("f7d8fb50757243f4a01336c80a3714fa"),
  img("6a90ca94f7e4401eb22f15cc12c04cfb"),
  img("85c2344431924bed8421b1d598770e75"),
  img("761fa13ffa3640d9ae8a7d778f431a8c"),
  img("1c773d40ad284e7eab14a861a7ff16f6"),
];

export const RIVER_PHOTOS = [
  img("f5b4697fdb1e4a899f90069256896317"),
  img("c6ce1e03aef6451ca240be030d53f028"),
  img("15cc2b5ddd574b0db231617a6b45d40b"),
  img("51890c94a5bc4f28b2613739952084cb"),
  img("0247aa3abb594a6ba4fc3f906b77d70e"),
  img("7c62713aaa0844aba21836f9465bac85"),
];

export const SOCIAL_PHOTOS = [
  img("c3c39711aa254063835b80531f447d25"),
  img("3e1c4327e2d44b638d2619c451225a1d"),
  img("e1af41009036484cab311b68fd75eb74"),
  img("a5431e2d0f424ae4a20bc42dd218ac45"),
  img("53a558f2b63c401980478cb2c920f815"),
  img("64f9c42798514f12af6fbcdb55d1331f"),
  img("6653fab96841469d80b3a3a1f15b1220"),
  img("6b87f0773e664dbbbfb935daf637140b"),
  img("68e7068ce91d4870b2b32aba5c6b8faa"),
  img("b3f244abb81441fb800ad02952bab161"),
  img("588c83cf847f46db85e9a46138c425af"),
  img("7288d2c03e814da3aba44fed380106c6"),
  img("0405c88d6e444db68f3f3f909b5999d2"),
];

export const CORPORATE_PHOTOS = [
  img("d1e88fc26f4743ee9c7eec29759465b4"),
  img("cc98f564e15d4df0a5096937bfff17ae"),
];

export const BRAND = {
  name: "The Big Wedd",
  tagline: "Luxury Wedding & Event Planners",
  locations: ["Jaipur", "Udaipur", "Goa", "Rishikesh"],
  phone: "+91 91192 02607",
  whatsapp: "919119202607",
  email: "thebigwedd@gmail.com",
  instagram: "https://instagram.com/thebigwedd",
};

export const WA_MSG = "Hi The Big Wedd! I'd love to discuss my wedding.";
export const waLink = (msg = WA_MSG) =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(msg)}`;

export const STATS = [
  { end: 350, decimals: 0, suffix: "+", label: "Weddings & Celebrations" },
  { end: 5, decimals: 0, suffix: "+", label: "Years of Experience" },
  { end: 4.8, decimals: 1, suffix: "/5", label: "Google Rating" },
  { end: 4, decimals: 0, suffix: "", label: "Signature Locations" },
];

export const WEDDING_STORIES = [
  {
    slug: "divyam-simran",
    couple: "Divyam & Simran",
    event: "The Wedding",
    venue: "Trident, Udaipur",
    style: "Palace Wedding",
    cat: "wedding",
    cover: P.gazeboFireworks,
    story:
      "A palace-side celebration in Udaipur — white blooms beneath the trees, chandeliers in the courtyards and a night the sky itself lit up in their honour.",
    photos: [P.moments, P.bridalPortrait, P.aisle, P.rituals, P.sunsetGarden, P.stageFireworks, P.decorVignettes, P.ceremony, P.gazeboFireworks, P.treeVenue],
  },
  {
    slug: "akshi-yash",
    couple: "Akshi & Yash",
    event: "The Wedding",
    venue: "Udaipur Marriott",
    style: "Palace Wedding",
    cat: "wedding",
    cover: img("3b186f0dce964eceafbd71dec2ac3750"),
    story:
      "A grand Udaipur wedding where every function was designed, produced and celebrated in style — from the first ritual to the final farewell.",
    photos: [
      img("3b186f0dce964eceafbd71dec2ac3750"), img("edbd40ae346140778cdeccee5bb89874"), img("53efb973aeef4f73b28bf907048506fd"),
      img("d7a69318d2de4d7c85b2fc79688b2297"), img("e81825b395314ad4804b9b26e78f117c"), img("9dfcf81073d84a6a92a151ac40fe6d5b"),
      img("3f52064c44fd4eab8d493d84213b5e79"), img("3ebdcd8a45c54a59a60ad6ff71ea2722"), img("67079bea047049708dc477d909c8283b"),
      img("22e4c27042c0475cb45f8cd4e7f5eb8c"), img("66ac1e0f4c3e4a08a28020e6451b401e"), img("a247e3f5e130422cb65f99aff8f4bdb1"),
      img("9eb60d164e384631b87feadda4bc8784"), img("1458d8b2bfd2420b937536673cb68896"), img("94570edb5b4641e4a0f1e87c5f990fe2"),
      img("c534e2b54dc74034b04efca51e4bb4c3"),
    ],
  },
  {
    slug: "nihal-khushbu-haldi",
    couple: "Nihal & Khushbu",
    event: "Haldi",
    venue: "Daulatgarh, Udaipur",
    style: "Haldi Celebration",
    cat: "haldi",
    cover: img("35ecb2693fc149e5b7e2b953efe2d6c4"),
    story:
      "A morning of turmeric, blooms and blessings at Daulatgarh, Udaipur — the couple drenched in yellow and completely in the moment.",
    photos: [
      img("35ecb2693fc149e5b7e2b953efe2d6c4"), img("117e6b8f1af54e52aa8eaf6ce9c55ecd"), img("6de5cd2870ff4eb3a5220eb4903075c2"),
      img("235900904e244d0a921920f525189e5d"), img("beb8377ba43749b69a00c3ecb20ae383"), img("750580b90f0842f095d8166594461062"),
      img("b6cdd595be1447c2a3d39572f702a6e5"), img("60f4ce69712a426584a2be9a0a123cce"), img("ce1f1e2c34de419ba1c1c2005b8e61b4"),
      img("71aa3aff9e4b48d78c99c3cb3f8ade9a"), img("ed2ea11f18d24be09bd64172a1c86b05"), img("6fb8512b61f7400e9e9a545f5432a3fb"),
      img("9a8bcf77e6bd493aa75f6b158455e6fd"), img("f8484000de6645a3b894586cd47502d4"), img("48e2b165f0494462a1ae2e88c4f23349"),
      img("108a447391d74882bdac74b6b437e371"), img("dfb4a43e55ec453d963665ca88277933"), img("7d1d8bcf76714ecfbd130c50829b6e8c"),
      img("cc84e0608669410396fd8442ddec9697"), img("86c8e20d3ac9481aaacaac1fff53e971"), img("3839283e3fd54b2e80b29fb23b4af7e2"),
      img("35006f05bc5c42ce8ee4e8d039a630a0"), img("c1995d8b597a46429e1370753718bb6f"),
    ],
  },
  {
    slug: "nihal-khushbu-sufi-night",
    couple: "Nihal & Khushbu",
    event: "Sufi Night",
    venue: "Daulatgarh, Udaipur",
    style: "Sangeet & Cocktail",
    cat: "sangeet",
    cover: img("0798356283a64cf7bcf685a3bb388b7f"),
    story:
      "An evening of sufi music, candlelight and celebration at Daulatgarh, Udaipur — voices that carried the night as the dance floor stayed warm.",
    photos: [
      img("0798356283a64cf7bcf685a3bb388b7f"), img("a73c32097787479e80479babeecfda0d"), img("6559155ba2eb4b4495dbaa3c2fd8990e"),
      img("ba8722a33b2e41af87b793c4cea8d91c"), img("6b9d7522a1b04d698fd4c192b7e6469b"), img("d764eb6062de4f1a8868a87fe40b92b2"),
      img("95fd29c2ad4f41b199acf01c89078476"), img("a7e48b4c2bf24b0c87ed105d120484d9"), img("152e132d717c44538cdf0c19f16d4f0e"),
      img("db1814fd7919441ebd511c11c99f3794"), img("8734a4a61b064e648c179a3e787e5e95"), img("c1c66ed1ed714ca79b0df8e2a0a33ddf"),
      img("ca9eed3d09b544b19e073e5ac771e0cf"), img("a3874c4d3c3d43a2a230db856c44132a"), img("22b3fb5d7d9144d48d4db38147ea9d3d"),
      img("3b5577943dbd4742b85b887434b12d6a"), img("26c36b6037064d3091bace0953bfd994"), img("8a619a878d194798b388287377a425ce"),
      img("c3e113e4e4d342f59a9a585a37bdc870"), img("04a6da2d246b4254bf4276432f2dfc19"), img("17e02d15569145e0a78f6aa969d4221a"),
    ],
  },
  {
    slug: "nihal-khushbu-sangeet",
    couple: "Nihal & Khushbu",
    event: "Sangeet",
    venue: "Daulatgarh, Udaipur",
    style: "Sangeet & Cocktail",
    cat: "sangeet",
    cover: img("8ad412f121d44a7cac8c52b83eaac715"),
    story:
      "The sangeet night — performances rehearsed in secret, a floor full of family, and a couple at the centre of it all.",
    photos: [
      img("8ad412f121d44a7cac8c52b83eaac715"), img("c63a09eefd33454db8189714ce91e1ce"), img("9801849c40e74416b90fb7a14f2a9986"),
      img("91a2abd39a2343f9833d72ac29f89f55"), img("c9445bd8d1524cbaa77281d604c2feb3"), img("81307a2500fe4dc6bf811d4b70e9ca50"),
      img("14fbd3ebff40442189ea01145cbda6a1"), img("cdea6ed52db145a1919988e581c41cba"), img("e51e37aa970540c2896742f418da3f1a"),
      img("4cf1a59b2f3e4c0581b97da8ed522951"), img("a5f7e49ac5e64a3f8f9d06a6ec0ca2f2"), img("67eff617539a40afa32fd6266334acd1"),
    ],
  },
  {
    slug: "vipul-hansika-haldi",
    couple: "Vipul & Hansika",
    event: "Haldi",
    venue: "Rajbagh Palace, Jaipur",
    style: "Haldi Celebration",
    cat: "haldi",
    cover: img("c0fe792d0e7c4583951a8b8c54d9bf7f"),
    story:
      "Haldi at Rajbagh Palace, Jaipur — royal lawns washed in yellow, marigolds in the air and joy without measure.",
    photos: [
      img("c0fe792d0e7c4583951a8b8c54d9bf7f"), img("71709fc701784aa08cd916d30ab81168"), img("a3183e06f1db44a89dca53b05dd84aaa"),
      img("97daaeab361a450c9a7a7b4583231266"), img("d4221a82217644d78b70fb273483c83e"), img("180a80a97a684bc880ec300d3580db84"),
      img("9d9cd41844954ae382616b12af1b737b"), img("e61dfa8db2fa47d3917ccf470f2d849d"), img("86805582196c437c9ae86bd0b265f416"),
    ],
  },
  {
    slug: "ishan-anamika-haldi",
    couple: "Ishan & Anamika",
    event: "Haldi",
    venue: "Venue to be announced",
    style: "Haldi Celebration",
    cat: "haldi",
    cover: img("ae0b7ad3e46d4f3f892acb75f723de85"),
    story:
      "An intimate haldi celebration — full story and venue details coming soon.",
    photos: [img("ae0b7ad3e46d4f3f892acb75f723de85"), img("bee1cce8fceb46089c942c6ebebb749b"), img("e71bb786d54c41cea8042df93d978eb4")],
  },
];

const A = WEDDING_STORIES[1].photos;
const H = WEDDING_STORIES[2].photos;
const F = WEDDING_STORIES[3].photos;
const S = WEDDING_STORIES[4].photos;
const V = WEDDING_STORIES[5].photos;

export const GALLERY_CATS = ["All", "Haldi", "Wedding", "Sangeet & Cocktail", "Beach Wedding", "Rishikesh River Wedding", "Palace Wedding", "Destination Weddings", "Business Events", "Social Events"];

export const GALLERY = [
  ...WEDDING_STORIES.flatMap((s) =>
    s.photos.map((src) => ({ src, cat: s.cat, story: s.slug, label: `${s.event} — ${s.venue}` }))
  ),
  ...BEACH_PHOTOS.map((src) => ({ src, cat: "beach", story: null, label: "Beach Wedding" })),
  ...RIVER_PHOTOS.map((src) => ({ src, cat: "river", story: null, label: "Rishikesh River Wedding" })),
  ...SOCIAL_PHOTOS.map((src) => ({ src, cat: "social", story: null, label: "Social Event" })),
  ...CORPORATE_PHOTOS.map((src) => ({ src, cat: "business", story: null, label: "Business Event" })),
  { src: P.gazeboFireworks, cat: "palace", story: "divyam-simran", label: "Palace Wedding — Udaipur" },
  { src: A[0], cat: "palace", story: "akshi-yash", label: "Palace Wedding — Udaipur" },
  { src: A[2], cat: "palace", story: "akshi-yash", label: "Palace Wedding — Udaipur" },
  { src: A[3], cat: "palace", story: "akshi-yash", label: "Palace Wedding — Udaipur" },
  { src: P.stageFireworks, cat: "destination", story: "divyam-simran", label: "Destination Wedding" },
  { src: RIVER_PHOTOS[0], cat: "destination", story: null, label: "Destination Wedding — Rishikesh" },
  { src: BEACH_PHOTOS[0], cat: "destination", story: null, label: "Destination Wedding — Beach" },
];

export const SCROLL_IMAGES = [
  { src: P.moments, label: "Wedding Decor", tall: false },
  { src: P.aisle, label: "The Processional", tall: true },
  { src: P.rituals, label: "Sacred Rituals", tall: false },
  { src: P.sunsetGarden, label: "Golden Hour", tall: true },
  { src: P.stageFireworks, label: "Sangeet Nights", tall: false },
  { src: P.decorVignettes, label: "Decor & Details", tall: true },
  { src: P.ceremony, label: "The Wedding Ceremony", tall: false, to: "/weddings/divyam-simran" },
  { src: P.treeVenue, label: "The Venue", tall: true },
  { src: A[1], label: "Palace Wedding — Udaipur", tall: false, to: "/weddings/akshi-yash" },
  { src: F[1], label: "Sufi Night", tall: true, to: "/weddings/nihal-khushbu-sufi-night" },
  { src: BEACH_PHOTOS[1], label: "Beach Wedding", tall: false, to: "/gallery" },
  { src: RIVER_PHOTOS[1], label: "River Wedding", tall: true, to: "/gallery" },
  { src: SOCIAL_PHOTOS[0], label: "Social Events", tall: false, to: "/gallery" },
];

export const WEDDING_STYLES = [
  { title: "Beach Wedding", desc: "Sunsets, tropical celebrations, coastal venues and ceremonies by the sea.", img: BEACH_PHOTOS[0], span: "md:col-span-2 md:row-span-2 h-[380px] md:h-full" },
  { title: "Palace Wedding", desc: "Royal Rajasthan celebrations in grand palaces and heritage properties.", img: A[2], span: "h-[380px]" },
  { title: "Resort Wedding", desc: "Luxury destination resort weddings with complete guest experiences.", img: A[3], span: "h-[380px]" },
  { title: "Rishikesh River Wedding", desc: "Soulful celebrations on the banks of the Ganga, beneath the hills.", img: RIVER_PHOTOS[0], span: "h-[380px]" },
  { title: "Destination Weddings", desc: "Complete destination wedding experiences across India and internationally.", img: S[1], span: "h-[380px]" },
  { title: "Custom Weddings", desc: "A celebration designed entirely around your vision, down to the last detail.", img: A[4], span: "h-[380px]" },
  { title: "Business Events", desc: "Corporate events, conferences, product launches and offsites — produced end to end.", img: CORPORATE_PHOTOS[0], span: "h-[380px]" },
  { title: "Social Events", desc: "Birthdays, anniversaries, engagements and milestone celebrations, beautifully styled.", img: SOCIAL_PHOTOS[1], span: "md:col-span-2 h-[380px]" },
];

export const SERVICES = [
  {
    title: "Wedding Services",
    tag: "Weddings",
    desc: "Complete wedding planning and execution under one roof.",
    items: ["Wedding planning", "Decor", "Designing", "Production", "Hospitality", "Guest management", "Logistics", "Show flow", "Vendor management", "Venue coordination", "On-ground execution"],
    img: A[5],
  },
  {
    title: "Corporate Services",
    tag: "Corporate",
    desc: "Corporate events designed with the same precision as a wedding.",
    items: ["Corporate events", "Conferences", "Product launches", "Brand events", "Annual celebrations", "Offsites", "Corporate hospitality"],
    img: CORPORATE_PHOTOS[1],
  },
  {
    title: "Social Events",
    tag: "Social",
    desc: "Personal milestones, celebrated beautifully.",
    items: ["Birthdays", "Anniversaries", "Engagements", "Private celebrations", "Cocktail parties", "Milestone celebrations", "Themed parties"],
    img: SOCIAL_PHOTOS[2],
  },
  {
    title: "Celebrity & Artist Management",
    tag: "Entertainment",
    desc: "The right names, the right acts, seamlessly managed.",
    items: ["Bollywood artists", "Singers", "DJs", "Live bands", "Performers", "Anchors", "Dancers", "Celebrity appearances", "Entertainment acts", "Artist coordination"],
    img: S[2],
  },
  {
    title: "Destination Weddings — India",
    tag: "Destinations",
    desc: "Planning and execution across destinations throughout India.",
    items: ["Rajasthan — Jaipur, Udaipur, Jodhpur", "Goa", "Rishikesh", "Kerala", "Andamans", "Hill stations", "Everywhere across India"],
    img: RIVER_PHOTOS[2],
  },
  {
    title: "Destination Weddings — Abroad",
    tag: "International",
    desc: "International destination wedding planning, coordination and execution.",
    items: ["Thailand", "Dubai", "Bali", "Turkey", "Vietnam", "Europe", "And beyond"],
    img: BEACH_PHOTOS[2],
  },
];

export const MANAGEMENT = [
  { title: "Planning", desc: "Concept development, timelines, budgets, vendor coordination and planning." },
  { title: "Decor & Designing", desc: "Mood boards, theme development, floral styling, stage design, tablescapes and venue transformation." },
  { title: "Photography & Videography", desc: "Photography and cinematography coordination." },
  { title: "Makeup & Beauty", desc: "Bridal makeup artists and hairstylists." },
  { title: "Mehendi", desc: "Bridal and guest mehendi artists." },
  { title: "Artist & Entertainment Management", desc: "DJs, singers, bands, dancers, anchors, performers and celebrities." },
  { title: "Hospitality", desc: "Guest welcome, rooming, transportation, guest assistance and hospitality." },
  { title: "Show Flow & Production", desc: "Event timelines, stage management, production and technical coordination." },
  { title: "Catering", desc: "Catering coordination and food experience management." },
  { title: "Complete Execution", desc: "Everything from the first meeting to the final farewell." },
];

export const PROCESS = [
  { num: "01", title: "Talk To Us", desc: "Tell us about your wedding, destination, dates, guest count, vision and requirements." },
  { num: "02", title: "Explore Your Options", desc: "We present suitable options for venues, decor, vendors, photography, entertainment, artists and pricing." },
  { num: "03", title: "Create Your Custom Package", desc: "We create a personalised proposal based on your requirements, priorities and budget." },
  { num: "04", title: "Book The Big Wedd", desc: "Once you're happy with the proposal, confirm your wedding with the required booking amount." },
  { num: "05", title: "Let Us Take It From Here", desc: "Our team manages the planning, coordination and execution while you enjoy your celebrations." },
];

export const QUALITY = [
  { title: "Thoughtful Planning", desc: "Understanding your vision and transforming it into a well-executed experience." },
  { title: "Curated Vendors", desc: "Working with reliable and quality-driven partners across decor, photography, catering, entertainment and other services." },
  { title: "Attention To Detail", desc: "Ensuring every element, from the smallest detail to the overall experience, is carefully considered." },
  { title: "Professional Execution", desc: "Maintaining organised planning, coordination and on-ground execution throughout the event." },
  { title: "Personalised Experiences", desc: "Creating celebrations around each client's individual story, preferences and requirements." },
  { title: "Transparent Communication", desc: "Keeping clients informed and involved throughout the planning journey." },
  { title: "End-to-End Responsibility", desc: "Bringing planning, designing, coordination and execution together under one roof." },
];

export const VENUE_DIRECTORY = [
  {
    city: "Goa",
    tagline: "Beach & Fort Celebrations",
    venues: [
      { name: "Taj Fort Aguada Resort & Spa", stars: 5.0, tag: "Beach Fort Icon", type: "Beach Fort Resort", location: "North Goa, Goa", capacity: "Capacity on request", price: null, inclusions: [], img: img("90cb5015a773416e8bef6df8be19705d") },
      { name: "Taj Exotica Resort & Spa", stars: 4.7, tag: "25 weddings hosted", type: "Beach Front Resort · 5★", location: "South Goa, Goa", capacity: "300+ guests", price: null, inclusions: ["Stay for 100 guests", "All meals", "Decor · Sangeet · Mehendi", "Concierge"], img: img("46c1592bb364439e9436f65d4a12f1ae") },
      { name: "Planet Hollywood Beach Resort", stars: 4.6, tag: "32 weddings hosted", type: "Pool Side · Beach Front", location: "North Goa, Goa", capacity: "200+ guests", price: null, inclusions: ["Stay for 80 guests", "All meals", "Venue rental", "Themes & services"], img: img("76a7fb05e5174158b8f0438a54c0bfe3") },
      { name: "La Cabana", stars: 4.3, tag: "14 weddings hosted", type: "Beach Front · 4★", location: "North Goa, Goa", capacity: "150+ guests", price: null, inclusions: [], img: px(9470486) },
      { name: "Beleza by the Beach", stars: 4.4, tag: "18 weddings hosted", type: "Beach Front · 4★", location: "South Goa, Goa", capacity: "200+ guests", price: null, inclusions: [], img: px(35670064) },
    ],
  },
  {
    city: "Jaipur",
    tagline: "Royal Palaces & Heritage Courtyards",
    venues: [
      { name: "The Leela Palace, Jaipur", stars: 5.0, tag: "Heritage Palace Icon", type: "Heritage Palace", location: "Jaipur, Rajasthan", capacity: "Capacity on request", price: null, inclusions: [], img: img("430ab2f8a8bf4546acc56abe7614f8fe") },
      { name: "Taj Jai Mahal Palace", stars: 4.7, tag: "", type: "Heritage Palace", location: "Jaipur, Rajasthan", capacity: "130–3000 guests", price: "₹7,500+/plate", inclusions: [], img: px(17397822) },
      { name: "Fairmont Jaipur", stars: 4.8, tag: "", type: "Palace Hotel", location: "Jaipur, Rajasthan", capacity: "500–700 guests", price: "₹5,000+/plate", inclusions: [], img: us("photo-1582998451055-5ce52763e246") },
      { name: "Rambagh Palace", stars: 4.7, tag: "", type: "Heritage Palace", location: "Jaipur, Rajasthan", capacity: "100–2000 guests", price: "₹10,000+/plate", inclusions: [], img: px(17911338) },
      { name: "Rajasthali Resort & Spa", stars: 4.3, tag: "28 weddings hosted", type: "Palace Style · 4★", location: "Jaipur, Rajasthan", capacity: "Up to 500 guests", price: null, inclusions: [], img: px(14036452) },
      { name: "Vijayran Palace", stars: 4.4, tag: "21 weddings hosted", type: "Palace Style · 4★", location: "Jaipur, Rajasthan", capacity: "Up to 350 guests", price: null, inclusions: [], img: us("photo-1663513844814-5f2fd51e957a") },
      { name: "The Raj Palace", stars: 4.5, tag: "", type: "Heritage Palace", location: "Jaipur, Rajasthan", capacity: "80–1200 guests", price: "₹5,000+/plate", inclusions: [], img: us("photo-1591946522651-90fbace43004") },
      { name: "Mundota Palace", stars: 4.4, tag: "", type: "Heritage Palace", location: "Jaipur, Rajasthan", capacity: "200–3500 guests", price: "₹4,000+/plate", inclusions: [], img: px(33667484) },
      { name: "Diggi Palace", stars: 4.4, tag: "", type: "Heritage Haveli", location: "Jaipur, Rajasthan", capacity: "120–1200 guests", price: null, inclusions: [], img: px(36562003) },
      { name: "Bhanwar Singh Palace", stars: 4.5, tag: "", type: "Palace", location: "Jaipur, Rajasthan", capacity: "100–2500 guests", price: "₹1,000+/plate", inclusions: [], img: px(33779661) },
      { name: "Bissau Palace", stars: 4.2, tag: "", type: "Heritage Palace", location: "Jaipur, Rajasthan", capacity: "600–1800 guests", price: "₹1,200+/plate", inclusions: [], img: us("photo-1721572321878-46fbef2e4bbd") },
      { name: "Nazarbagh Palace", stars: 4.1, tag: "", type: "Palace", location: "Jaipur, Rajasthan", capacity: "800–2500 guests", price: "₹1,200+/plate", inclusions: [], img: px(28133705) },
      { name: "Hotel Rajasthan Palace", stars: 4.6, tag: "", type: "Palace Hotel", location: "Jaipur, Rajasthan", capacity: "150–300 guests", price: "₹1,500+/plate", inclusions: [], img: us("photo-1782939355849-4a748ada9c84") },
      { name: "Fort Chandragupt", stars: 3.8, tag: "", type: "Fort Theme", location: "Jaipur, Rajasthan", capacity: "100–300 guests", price: "₹1,000+/plate", inclusions: [], img: us("photo-1710689208379-2b2f1c6620ca") },
      { name: "Pratishtha Banquets", stars: 5.0, tag: "", type: "Banquet & Lawns", location: "Jaipur, Rajasthan", capacity: "500–750 guests", price: "₹1,600+/plate", inclusions: [], img: px(6626128) },
    ],
  },
  {
    city: "Udaipur",
    tagline: "Lakes, Palaces & Golden Hours",
    venues: [
      { name: "Taj Lake Palace", stars: 4.8, tag: "", type: "Lake Palace", location: "Udaipur, Rajasthan", capacity: "50–500 guests", price: "₹12,500+/plate", inclusions: [], img: px(27960113) },
      { name: "The Oberoi Udaivilas", stars: 4.8, tag: "", type: "Luxury Resort", location: "Udaipur, Rajasthan", capacity: "25–800 guests", price: "₹8,500+/plate", inclusions: [], img: us("photo-1724947053227-2335bf21d0ae") },
      { name: "The Leela Palace, Udaipur", stars: 4.7, tag: "", type: "Lake Palace", location: "Udaipur, Rajasthan", capacity: "10–750 guests", price: "₹8,000+/plate", inclusions: [], img: us("photo-1706961121527-4017856774c7") },
      { name: "Holymont", stars: 4.8, tag: "", type: "Grand Palace Venue", location: "Udaipur, Rajasthan", capacity: "1250–1500 guests", price: "₹3,500+/plate", inclusions: [], img: us("photo-1589901164570-f9de6556e1c1") },
      { name: "Bamboosa Resort and Spa", stars: 4.8, tag: "", type: "Resort & Spa", location: "Udaipur, Rajasthan", capacity: "60–600 guests", price: "₹1,500+/plate", inclusions: [], img: us("photo-1766603636671-484c4911a84b") },
      { name: "Ramee Royal Resort & Spa", stars: 4.7, tag: "", type: "Resort & Spa", location: "Udaipur, Rajasthan", capacity: "500–800 guests", price: "₹900+/plate", inclusions: [], img: us("photo-1701421016474-09b19faa9f77") },
      { name: "Fateh Niwas by Fateh Collection", stars: 4.4, tag: "", type: "Heritage Hotel", location: "Udaipur, Rajasthan", capacity: "50–900 guests", price: "₹1,800+/plate", inclusions: [], img: us("photo-1695956353120-54ce5e91632b") },
      { name: "Bhairavgarh Palace", stars: 4.3, tag: "", type: "Palace", location: "Udaipur, Rajasthan", capacity: "50–900 guests", price: "₹1,800+/plate", inclusions: [], img: px(35455624) },
      { name: "Indira Niwas", stars: 4.4, tag: "", type: "Heritage Niwas", location: "Udaipur, Rajasthan", capacity: "30–100 guests", price: "₹550+/plate", inclusions: [], img: us("photo-1710691166527-593758978b6f") },
      { name: "Justa Rajputana Resort & Spa", stars: 4.2, tag: "", type: "Resort & Spa", location: "Udaipur, Rajasthan", capacity: "200–800 guests", price: "₹1,600+/plate", inclusions: [], img: us("photo-1549294413-26f195200c16") },
      { name: "Padmini Bagh Resort", stars: 4.3, tag: "", type: "Resort", location: "Udaipur, Rajasthan", capacity: "80–2000 guests", price: "₹800+/plate", inclusions: [], img: px(9228503) },
      { name: "Mewar Palace Resort", stars: 4.3, tag: "", type: "Resort", location: "Udaipur, Rajasthan", capacity: "120–2000 guests", price: "₹1,000+/plate", inclusions: [], img: px(33828124) },
    ],
  },
  {
    city: "Rishikesh",
    tagline: "Blessings By The Ganga",
    venues: [
      { name: "The Westin Resort & Spa, Himalayas", stars: 4.6, tag: "", type: "Luxury Resort", location: "Rishikesh, Uttarakhand", capacity: "750–1000 guests", price: "₹4,500+/plate", inclusions: [], img: us("photo-1712510817140-917938f92e5b") },
      { name: "Taj Rishikesh Resort & Spa", stars: 4.5, tag: "", type: "Luxury Resort", location: "Rishikesh, Uttarakhand", capacity: "100–250 guests", price: "₹7,000+/plate", inclusions: [], img: px(19511794) },
      { name: "Aloha On The Ganges", stars: 4.4, tag: "", type: "Riverside Resort", location: "Rishikesh, Uttarakhand", capacity: "30–200 guests", price: "₹1,500+/plate", inclusions: [], img: us("photo-1645873324895-09879e84bfd6") },
      { name: "Antalya By Divine Ganga Cottage", stars: 4.5, tag: "", type: "Ganga Cottage", location: "Rishikesh, Uttarakhand", capacity: "70–100 guests", price: "₹1,500+/plate", inclusions: [], img: us("photo-1650341259809-9314b0de9268") },
      { name: "Namami Ganges Beach Resort & Spa", stars: 4.3, tag: "", type: "Beach Resort", location: "Rishikesh, Uttarakhand", capacity: "100–200 guests", price: "₹1,900+/plate", inclusions: [], img: px(6157502) },
      { name: "Raga on the Ganges", stars: 4.3, tag: "", type: "Riverside Resort", location: "Rishikesh, Uttarakhand", capacity: "100–120 guests", price: "₹1,500+/plate", inclusions: [], img: us("photo-1570804485046-b5b8d795dc5d") },
    ],
  },
  {
    city: "Shimla",
    tagline: "Mountain Air, Hill Celebrations",
    venues: [
      { name: "Kamna Hill Resorts", stars: 4.5, tag: "", type: "Hill Resort", location: "Shimla, Himachal Pradesh", capacity: "50–100 guests", price: "₹200+/plate", inclusions: [], img: us("photo-1783282589177-410062c17abd") },
      { name: "The Royal Regency Shimla", stars: 4.4, tag: "", type: "Hill Resort", location: "Shimla, Himachal Pradesh", capacity: "50–100 guests", price: "₹200+/plate", inclusions: [], img: px(32862097) },
      { name: "Hotel Peterhoff", stars: 4.3, tag: "", type: "Colonial Hotel", location: "Shimla, Himachal Pradesh", capacity: "50–100 guests", price: "₹200+/plate", inclusions: [], img: us("photo-1766391606898-92e9075a1a47") },
    ],
  },
];

export const IDEAS = [
  { title: "Lehenga & Bridal Fashion", img: A[13], items: ["Lehenga designs", "Bridal looks", "Sarees", "Colour combinations"] },
  { title: "Decor", img: F[3], items: ["Mandap designs", "Stage designs", "Haldi decor", "Mehendi decor", "Sangeet decor", "Reception decor", "Table styling", "Floral ideas"] },
  { title: "Makeup", img: A[14], items: ["Bridal makeup", "Makeup inspiration", "Beauty looks"] },
  { title: "Hairstyles", img: V[3], items: ["Bridal hairstyles", "Hair accessories", "Wedding hair inspiration"] },
  { title: "Mehendi", img: H[3], items: ["Bridal mehendi", "Guest mehendi", "Mehendi design inspiration"] },
  { title: "Photography", img: A[15], items: ["Couple poses", "Pre-wedding photography", "Wedding photography", "Creative shots"] },
  { title: "Entertainment", img: S[3], items: ["Sangeet ideas", "Baraat ideas", "Bride/groom entry ideas", "Artist inspiration"] },
  { title: "Wedding Details", img: SOCIAL_PHOTOS[3], items: ["Invitations", "Stationery", "Welcome hampers", "Guest experiences", "Favours", "Seating ideas"] },
];

export const TESTIMONIALS = [
  { couple: "Divyam & Simran", place: "Trident, Udaipur", img: P.gazeboFireworks, review: "The Big Wedd made our wedding at Trident Udaipur feel like a dream we got to live. Every artist arrived on time, every entry happened to the minute, and the execution was flawless from the first ritual to the final farewell. Thank you, Isha, for treating our celebration like your own — we actually got to be guests at our own wedding." },
  { couple: "Akshi & Yash", place: "Udaipur Marriott", img: A[0], review: "From the haldi to the reception, The Big Wedd ran our three days at Udaipur Marriott like clockwork. Makeup artists were always on schedule, entries and show flow were timed to perfection, and not one guest was left waiting. Isha, your calm and personal attention through every decision — thank you, from the bottom of our hearts." },
  { couple: "Nihal & Khushbu", place: "Daulatgarh, Udaipur", img: H[0], review: "Our haldi, sufi night and sangeet at Daulatgarh were pure magic. The Big Wedd team was on time, every single time — artists, entries, sound, everything ran exactly to plan. Isha, thank you for the perfect execution and for caring about the little details more than we did." },
  { couple: "Vipul & Hansika", place: "Rajbagh Palace, Jaipur", img: V[0], review: "The Big Wedd turned our haldi at Rajbagh Palace into the most beautiful morning of our lives. Timely artists, perfectly coordinated entries and execution that never missed a beat. Isha, your personal touch and warmth made the whole journey so easy — thank you for everything." },
  { couple: "Ishan & Anamika", place: "Udaipur", img: WEDDING_STORIES[6].photos[0], review: "Choosing The Big Wedd was the best decision we made for our wedding. Every function ran on time, every artist and every entry was perfectly coordinated, and the on-ground execution was flawless. Thank you, Isha, for your patience, your warmth and your relentless perfection — our families are still talking about it." },
];

export const GOOGLE_RATING = { score: "4.8", outOf: "5", source: "Google" };

export const IMG = {
  hero: P.heroJoyful,
  founder: "https://customer-assets-lqy194kg.emergentagent.net/job_emerald-celebrations-1/artifacts/3090e5fe33732555_Elegant%20Yellow%20Lehenga%20Portrait.png",
  storyA: F[9],
  storyB: F[8],
  storyC: F[7],
  whyBigWedd: F[4],
  ctaWide: F[5],
  servicesHero: S[6],
  venuesHero: H[7],
  galleryHero: F[10],
  ideasHero: SOCIAL_PHOTOS[8],
  testimonialsHero: F[11],
  teaserA: COUPLE_PHOTOS[0],
  teaserB: COUPLE_PHOTOS[1],
};

export const INSTAGRAM = [
  SOCIAL_PHOTOS[5], SOCIAL_PHOTOS[6], BEACH_PHOTOS[6], H[5],
  S[5], V[5], F[6], SOCIAL_PHOTOS[7],
];

export const LATEST_WORK = [
  { img: BEACH_PHOTOS[5], tag: "Beach Wedding", title: "Shoreline Ceremonies", place: "Goa", to: "/gallery" },
  { img: RIVER_PHOTOS[5], tag: "River Wedding", title: "Blessed by the Ganga", place: "Rishikesh", to: "/gallery" },
  { img: SOCIAL_PHOTOS[4], tag: "Social Event", title: "Celebrations & Soirées", place: "Jaipur", to: "/gallery" },
  { img: H[4], tag: "Haldi", title: "Marigold Mornings", place: "Udaipur", to: "/weddings/nihal-khushbu-haldi" },
  { img: V[4], tag: "Haldi", title: "Royal Haldi", place: "Rajbagh Palace, Jaipur", to: "/weddings/vipul-hansika-haldi" },
  { img: S[4], tag: "Sangeet", title: "Dance Floor Nights", place: "Udaipur", to: "/weddings/nihal-khushbu-sangeet" },
];

export const WHY = [
  "End-to-end planning", "Personalised concepts", "Destination wedding expertise", "Creative decor & design",
  "Vendor coordination", "Professional execution", "Hospitality management", "Artist & entertainment management",
  "Budget-conscious planning", "Personal attention",
];

export const PROPOSAL_SAMPLE = {
  couple: "Ananya & Arjun",
  date: "14th — 16th November 2025",
  destination: "Udaipur, Rajasthan",
  guests: "180 Guests",
  pack: "5 Events · 3-Day Celebration Pack",
  events: [
    { name: "Haldi", addons: ["DJ", "Decor Style"], budget: { stays: "₹3.0 Lakh", decor: "₹2.1 Lakh", artist: "₹0.9 Lakh" }, total: "₹6.0 Lakh" },
    { name: "Mehendi", addons: ["Anchor", "Decor Style"], budget: { stays: "₹2.5 Lakh", decor: "₹1.75 Lakh", artist: "₹0.75 Lakh" }, total: "₹5.0 Lakh" },
    { name: "Sangeet", addons: ["DJ", "Anchor"], budget: { stays: "₹4.5 Lakh", decor: "₹3.15 Lakh", artist: "₹1.35 Lakh" }, total: "₹9.0 Lakh" },
    { name: "Wedding", addons: ["DJ", "Anchor", "Decor Style"], budget: { stays: "₹11.0 Lakh", decor: "₹7.7 Lakh", artist: "₹3.3 Lakh" }, total: "₹22.0 Lakh" },
    { name: "Reception", addons: ["DJ", "Decor Style"], budget: { stays: "₹4.0 Lakh", decor: "₹2.8 Lakh", artist: "₹1.2 Lakh" }, total: "₹8.0 Lakh" },
  ],
  grandTotal: "₹50 Lakh",
};
